import React, { useContext, useState, useRef, useEffect } from "react";
import Headroom from "react-headroom";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "./Header.css";

const Header = () => {
  const { isLoggedIn, userInitials, userName, logout } = useContext(AuthContext);
  const [showLogoutMenu, setShowLogoutMenu] = useState(false);
  const logoutMenuRef = useRef(null);
  const initialsButtonRef = useRef(null);
  const location = useLocation();

  const handleInitialsClick = (e) => {
    e.stopPropagation();
    setShowLogoutMenu(prev => !prev);
  };

  const handleLogout = () => {
    logout();
    setShowLogoutMenu(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        logoutMenuRef.current &&
        !logoutMenuRef.current.contains(event.target) &&
        initialsButtonRef.current &&
        !initialsButtonRef.current.contains(event.target)
      ) {
        setShowLogoutMenu(false);
      }
    };

    if (showLogoutMenu) {
      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
    }
  }, [showLogoutMenu]);

  // Close menu on scroll
  useEffect(() => {
    const handleScroll = () => setShowLogoutMenu(false);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Headroom>
      <header className="header">
        <Link to="/home" className="logo" aria-label="Math Break Down home">
          <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Math Break Down" className="logo-img" />
        </Link>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn">
          <span className="navicon"></span>
        </label>
        <ul className="menu">
          <li>
            <Link to="/home">Home</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
          {isLoggedIn ? (
            <>
              <li>
                <Link to="/saved-exercises" className="menu-link">Saved Exercises</Link>
              </li>
              <li className="user-menu-item">
                <button
                  ref={initialsButtonRef}
                  className="user-initials-btn"
                  onClick={handleInitialsClick}
                >
                  {userInitials}
                </button>
              </li>
            </>
          ) : (
            <li>
              <Link to="/login">Login</Link>
            </li>
          )}
        </ul>

        {showLogoutMenu && (
          <div className="user-profile-card" ref={logoutMenuRef}>
            <div className="profile-card-top">
              <div className="profile-card-avatar">{userInitials}</div>
              <p className="profile-card-name">{userName || userInitials}</p>
            </div>
            <div className="profile-card-divider" />
            <div className="profile-card-actions">
              <button className="profile-card-signout-btn" onClick={handleLogout}>
                Sign out
              </button>
            </div>
          </div>
        )}
      </header>
    </Headroom>
  );
};

export default Header;
